/**
 * FooterConfigBlock registration.
 * Self-registering block following the Juizi block pattern.
 *
 * Restriction: this block only appears in the block chooser when the
 * current content item has the id "footer". This enforces the convention
 * that footer config lives at /footer (or /[lang]/footer).
 */

import footerSVG from '@plone/volto/icons/server.svg';
import FooterConfigEdit from './Edit';
import FooterConfigView from './View';

export const installFooterConfigBlock = (config) => {
  config.blocks.blocksConfig.footerConfig = {
    id: 'footerConfig',
    title: 'Footer Configuration',
    icon: footerSVG,
    group: 'common',
    edit: FooterConfigEdit,
    view: FooterConfigView,
    restricted: ({ properties, block }) => {
      // Only allow this block on pages with the short name "footer"
      const contentId = properties?.['@id'] || '';
      const segments = contentId.split('/').filter(Boolean);
      const shortName = segments[segments.length - 1];
      return shortName !== 'footer';
    },
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };

  return config;
};
